var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('size-form',{attrs:{"title":"sizes.edit_size","initialSize":_vm.size},on:{"save":_vm.save,"cancel":_vm.cancel}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }